import http from "@/http/http-common";
const resource = "/api/frontend";
class SearchService {
    search(content) {
        return http.get(`${resource}/search?search=${content}`);
        // return http.get(`${resource}/search?search=uu&per_page=2&page=4`);
    }
}

export default new SearchService();